import { render, staticRenderFns } from "./NetworkStatus.vue?vue&type=template&id=2078ae07"
import script from "./NetworkStatus.vue?vue&type=script&lang=js"
export * from "./NetworkStatus.vue?vue&type=script&lang=js"
import style0 from "./NetworkStatus.vue?vue&type=style&index=0&id=2078ae07&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports